import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

function MyVerticallyCenteredModal({purchaseHash, props }) {
  return (
    <Modal
      className="wallet-modal"
      
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Transactions Hashes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
   
        <div>
          <h3>Transaction Hash:</h3>
          <p>{purchaseHash}</p>
        </div>
      
      </Modal.Body>
    </Modal>
  );
}

export default function HashModal({hashModalOpen}) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <MyVerticallyCenteredModal
        show={hashModalOpen}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}
